var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_https_rs_shop_rscom_prod_awsext_repsrv_com_remoteEntry_mjs_c35f45dd__;